import React from 'react';
import AppProvider from "./../../Components/bootstrap"
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import arrayMutators from 'final-form-arrays';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { Form } from 'react-final-form';
import { ArrayInput, SimpleFormIterator, FormDataConsumer, CheckboxGroupInput,useAuthenticated } from 'react-admin';
import { DateInput, TimeInput } from "./../../Components/Pickers/index"

import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },

    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    TextField: {
        marginTop: "8%",
        backgroundColor: "#ffffff"
    },
    coverBackgroundContainer: {
        backgroundColor: "#F7F8F9",
        height: "100vh",
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: "4%",
        paddingRight: "4%",
        paddingTop: "40px",
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
        width: '100%'
    },
    buttonSuccess: {
        backgroundColor: 'primary',
        width: '100%',
        '&:hover': {
            backgroundColor: 'primary',
        },
    },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

const defaultSubscription = {
    submitting: true,
    pristine: true,
    valid: true,
    invalid: true,
};

const SelectTimeSlotForm = ({ handleSubmit, reset, submitting, pristine, values }) => {
    useAuthenticated()
    console.log(values)
    return (<form onSubmit={handleSubmit} noValidate>
        <ArrayInput source="availability_slots" label="Availability Slots">
            <SimpleFormIterator>
                <DateInput source="date" label="Date" />
                <FormDataConsumer>
                    {({ formData, ...rest }) => {
                        return (
                            <CheckboxGroupInput
                                {...rest}
                                source="category"
                                choices={[
                                    { id: 'programming', name: 'Programming' },
                                    { id: 'lifestyle', name: 'Lifestyle' },
                                    { id: 'photography', name: 'Photography' },
                                ]} />
                        );
                    }}
                </FormDataConsumer>
                <TimeInput source="toTime" label="To (Time)" options={{ format: "hh:mmaaaaa'm'" }} />
            </SimpleFormIterator>
        </ArrayInput>
        <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
        >
            Submit Details
     </Button>
    </form>)
}

export default function SelectTimeSlotCo() {
    const onSubmitTimeSlot = async (values) => {
        console.log(values)
    }

    const classes = useStyles();

    return (
        <AppProvider>
            <div className={classes.coverBackgroundContainer}>
                <Container component="main" maxWidth="xs" style={{ background: "#ffffff", }}>
                    <Typography component="h6" variant="h6" style={{ paddingTop: "7%", marginLeft: "20%" }}>
                        Select Availability Slot
                  </Typography>
                    <Form
                        mutators={{ ...arrayMutators }} // necessary for ArrayInput
                        subscription={defaultSubscription} // don't redraw entire form each time one field changes
                        keepDirtyOnReinitialize
                        onSubmit={onSubmitTimeSlot}
                        render={SelectTimeSlotForm}
                    />
                </Container>
            </div>
        </AppProvider>
    );
}
